// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingPrintSpinner_spinner__Mah0Z","rotate":"LoadingPrintSpinner_rotate__acyzI","path":"LoadingPrintSpinner_path__X6jsM","dash":"LoadingPrintSpinner_dash__gJh2K"};